"use client";

import { show } from "@intercom/messenger-js-sdk";
import type { LinkProps } from "@mui/material";
import { Link } from "@mui/material";
import { type FC, type MouseEvent } from "react";

export interface IntercomButtonProps extends Omit<LinkProps, "onClick"> {
  text: string;
}

export const IntercomButton: FC<IntercomButtonProps> = ({
  text,
  color = "info",
  sx,
  ...props
}) => {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    show();
  };

  return (
    <Link
      {...props}
      color={color}
      onClick={handleClick}
      sx={{ cursor: "pointer", ...sx }}
    >
      {text}
    </Link>
  );
};
